import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { EssenceBalance } from '@sorare/core/src/components/balance/EssenceBalance';
import { GemsBalance } from '@sorare/core/src/components/commonGame/GemsBalance';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSeriesNav } from '@sorare/core/src/hooks/commonGame/useSeriesNav';
import { getCommonCardShardsCount } from '@sorare/core/src/lib/currentUser';
import { useCommonGameSet, useSupportedCardSets } from '@sorare/core/src/set';

type Props = {
  cardSetSlugs?: readonly string[];
};
export const SeriesBalance = ({ cardSetSlugs }: Props) => {
  const supportedCardSets = useSupportedCardSets();
  const resolvedCardSetSlugs = cardSetSlugs ?? supportedCardSets;
  const commonGameSet = useCommonGameSet();
  const { currentUser } = useCurrentUserContext();
  const isSimplifiedNav = useSeriesNav();

  return (
    <Horizontal>
      <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
      {resolvedCardSetSlugs.map(
        slug =>
          (slug === commonGameSet.cardSet.activeSlug ||
            (slug === commonGameSet.cardSet.baseSlug && !isSimplifiedNav)) && (
            <EssenceBalance
              key={slug}
              value={getCommonCardShardsCount(currentUser, slug) || 0}
              rarity={Rarity.common}
              cardSetSlug={slug}
            />
          )
      )}
    </Horizontal>
  );
};
